import React from 'react'
// libs
import { useMutation } from '@apollo/client/react'
// components
import { Menu } from 'components/UI'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useCurrentUser } from 'hooks/useCurrentUser'
// context
import { RiskViewAPIContext } from 'containers/Risks/RiskView/layers/API'
// views
import { DotsIcon } from './views'
// constants
import { Modals } from 'constants/modals'
// graphql
import { RISK_VIEW_FILTER_DELETE_MUTATION } from 'graphql/risk/mutations'
// types
import { IFilter } from 'types/graphql'
// utils
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

interface Props {
  filter: IFilter
}

const TabMenu: React.FC<Props> = ({ filter }) => {
  const user = useCurrentUser()

  const [deleteFilterMutation] = useMutation(RISK_VIEW_FILTER_DELETE_MUTATION)

  const { currentTab, setAppliedFilters, setOrder, filtersRefetch } = React.useContext(RiskViewAPIContext)

  const { showModal } = useShowModal({ modalType: Modals.RISK_VIEW_FILTER_MODAL })
  const { showModal: showConfirmModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MODAL })
  const { showModal: showAddFilterModal } = useShowModal({ modalType: Modals.RISK_VIEW_ADD_FILTER_MODAL })

  const canEdit = filter.args.global
    ? user.permissionsFromSecurityGroups.manageRiskTemplates
    : Boolean(filter.createdById === user.id)

  const deleteFilter = async () => {
    try {
      await deleteFilterMutation({
        variables: {
          input: {
            id: filter.id
          }
        }
      })

      filtersRefetch()

      if (currentTab === filter.id) {
        setOrder(null)
        setAppliedFilters(null)
      }
    } catch (e) {
      console.log('[FilterTab.deleteFilter]:', parseGraphQLErrorMessages(e))
    }
  }

  const onDeleteClick = () => {
    showConfirmModal({
      width: 'sm',
      handleConfirm: deleteFilter
    })
  }

  const onRenameClick = () => {
    showAddFilterModal({ filter })
  }

  const onClickModify = () => {
    showModal({ data: filter })
  }

  const onClickClone = () => {
    showModal({ data: filter, isClone: true })
  }

  return (
    <Menu trigger={<DotsIcon />}>
      {canEdit && <span onClick={onRenameClick}>Rename</span>}
      {canEdit && <span onClick={onClickModify}>Modify</span>}
      {canEdit && <span onClick={onDeleteClick}>Delete</span>}
      <span onClick={onClickClone}>Clone</span>
    </Menu>
  )
}

export default TabMenu
